<template>
  <div class="rattachements__top">
    <BasicButton
      icon-name="profile"
      label="Demander un rattachement"
      @click="demanderRattachement"
      class="rattachements__top--demande"
    />
  </div>
  <RattachementsUtilisateurView />
</template>

<script setup lang="ts">
  import RattachementsUtilisateurView from '@/features/interface/profil-utilisateur/rattachements/utilisateur/RattachementsUtilisateurView.vue'
  import { useDemandeRattachement } from '../rattachements/demande/useDemandeRattachement'

  async function demanderRattachement() {
    const rattachementManager = useDemandeRattachement()
    await rattachementManager.showDialog()
  }
</script>
<style lang="less">
  .rattachements__top {
    display: flex;
    justify-content: end;
    flex-wrap: nowrap;
    gap: @spacing-20;

    &--choix {
      width: 400px;
    }
  }

  @container (max-width: @breakpoint-mobile) {
    .rattachements__top {
      flex-direction: column;
      &--choix {
        flex: 1;
        width: 100%;
      }
    }
  }
</style>
